import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { ga } from 'helpers/multitrack';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
export var ProductTourTeaserUnwrapped =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ProductTourTeaserUnwrapped, _PureComponent);

  function ProductTourTeaserUnwrapped() {
    _classCallCheck(this, ProductTourTeaserUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductTourTeaserUnwrapped).apply(this, arguments));
  }

  _createClass(ProductTourTeaserUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Product Tour Teaser Module', 'Viewed product tour teaser module', null, 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "bg--".concat(this.props.backgroundColor || 'white')
      }, React.createElement("div", {
        className: "product-tour-teaser"
      }, React.createElement("div", {
        className: "product-tour-teaser__content"
      }, React.createElement("div", null, React.createElement(FormattedMessage, {
        tagName: "h3",
        id: "ProductTourTeaser.title",
        defaultMessage: "See how it works"
      }), React.createElement(FormattedMessage, {
        tagName: "p",
        id: "ProductTourTeaser.body",
        defaultMessage: "Get a glimpse in to how you can book classes, watch videos, and interact with a community to tap in to your healthiest self."
      }), React.createElement(Link, {
        className: "bt bt--primary bt--lg",
        to: "/features"
      }, React.createElement(FormattedMessage, {
        id: "ProductTourTeaser.cta",
        defaultMessage: "Learn more"
      })))), React.createElement("div", {
        className: "product-tour-teaser__image"
      })));
    }
  }]);

  return ProductTourTeaserUnwrapped;
}(PureComponent);
ProductTourTeaserUnwrapped.propTypes = {
  backgroundColor: PropTypes.oneOf(['white', 'light'])
};
export var ProductTourTeaser = trackDwell(ProductTourTeaserUnwrapped);